import { ClientType } from '@types';

import { ClientItem } from '../clientItem/ClientItem';

import styles from './clientsList.module.scss';

type ClientItemsListProps = {
	clients: ClientType[];
	onSelect: (client: ClientType) => void;
};

export const ClientsList = ({ clients, onSelect }: ClientItemsListProps) => {
	return (
		<div className={styles.wrapper} data-testid="clientsWrapper">
			{clients.map((client, index) => (
				<div className={styles.clientItemwrapper} key={index}>
					<ClientItem
						clientItem={client}
						selectable
						key={index}
						testId="clientItem"
						onSelect={onSelect}
					/>
				</div>
			))}
		</div>
	);
};
